<template>
  <nav class="menu fixed pin-b pin-l w-full bg-blue-dark shadow z-30">
    <div>
      <div class="flex justify-between">
        <div class="text-white opacity-5 text-xs text-left px-4 py-2">
          <p>{{ name }}</p>
          <p> {{ serverTime[0] }} </p>
          <p> {{ serverTime[1] }} </p>
        </div>
        <div class="text-white text-right text-xs px-4 py-2">
          <div class="flex">
            <p class="text-right">
              <i class="fas fa-phone text-white align-middle pt-2"></i>
            </p>
            <p class="text-left pl-2">
              <span class="opacity-75">{{$t('all.customer_care')}} </span><br>
              <a
                href="tel:800035850"
                class="text-white opacity-50 no-underline"
              >
                800 035 850 </a>
            </p>
          </div>
          <div class="flex">
            <p class="text-right">
              <i class="fas fa-envelope text-white align-baseline"></i>
            </p>
            <p class="text-left pl-2">
              <a
                href="mailto:scrivi@camillo.online"
                class="text-left text-white opacity-50 no-underline"
              > scrivi@camillo.online </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      name: 'authentication/name',
      serverTime: 'authentication/serverTime',
    })
  },
  methods: {
    ...mapActions('authentication', ['getServerTime', 'getUserInfo'])
  },
  created() {
    const _this = this;
    _this.getUserInfo();
    _this.getServerTime();
    setInterval(() => {
      _this.getServerTime();
    }, 60000);
  }
};
</script>
